// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// global js and css
import './env.js'
import 'flexboxgrid/dist/flexboxgrid.min.css'
import './styles.styl'
// app and router
import App from './App'
import router from './router'

// plugin configuration
import 'plugin-config/v-touch'
import stock from 'plugin-config/stock'
import 'plugin-config/toast'
import BusinessApi from '@/plugins/business-api' // business 后端接口
import MarketProxy from '@/plugins/market-proxy'

import createDeferred from '@/helpers/create-deferred'

import config from '@/config'

require('es6-promise').polyfill()

Vue.config.productionTip = false

Vue.use(BusinessApi)
Vue.use(MarketProxy)

async function loadJsBridge () {
  const deferred = createDeferred()

  document.addEventListener('YTXBridgeReady', () => {
    window.YTXBridge ? deferred.resolve() : deferred.redirect()
  })

  return deferred.promise
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  stock,
  template: '<App/>',
  components: { App },
  businessApi: new BusinessApi(config.businessApi),
  marketProxy: new MarketProxy(config.marketProxy),
  async beforeCreate () {
    if (!window.YTXBridge) {
      await loadJsBridge()
    }
    window.YTXBridge.init(function () { })
  }
})



// WEBPACK FOOTER //
// ./src/main.js